import { readHostColorScheme, type HostProvider } from '@tasks/bridge-client/host';
import { type ReactNode, useEffect, useRef, useSyncExternalStore } from 'react';

/** Only mounted in embedded mode. Presentation from the trusted grant host, never authority. */
export const HostTheme = ({ host, children }: { host: HostProvider; children: ReactNode }) => {
  const colorScheme = useSyncExternalStore(host.subscribe, () =>
    readHostColorScheme(host.colorScheme?.()),
  );
  const applied = useRef<string | undefined>(undefined);
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.getAttribute('data-theme');
    return () => {
      if (applied.current === undefined || root.dataset.theme !== applied.current) return;
      if (previous === null) root.removeAttribute('data-theme');
      else root.setAttribute('data-theme', previous);
      applied.current = undefined;
    };
  }, []);
  useEffect(() => {
    if (colorScheme === undefined) return;
    document.documentElement.dataset.theme = colorScheme;
    applied.current = colorScheme;
  }, [colorScheme]);
  return children;
};
